import React from 'react'
import { Container, Top } from '../styles'
import { DefaultAdminPage } from '../../DefaultPages'
import SendInvites from './SendInvites'

import { Breadcrumbs, InsideFooter } from '../../../components'
import { Description } from './styles'
import PendingInvites from './PendingInvites'
import EventListener from '../../../utils/EventListener'
import UserList from './UserList'

const Users = () => {
  const usersEventListener = new EventListener()

  return (
    <DefaultAdminPage page="usuarios">
      <Container>
        <Top>
          <Breadcrumbs />
          {/* <Button
            type="button"
            variant="outlined"
            text="Exportar excel"
            width="120px"
          /> */}
        </Top>
        <Description>
          Aqui você pode gerenciar todos os usuários do sistema de administração
          ECBR
        </Description>
        <SendInvites eventListener={usersEventListener} />
        <PendingInvites eventListener={usersEventListener} />
        <UserList eventListener={usersEventListener} />
        <InsideFooter />
      </Container>
    </DefaultAdminPage>
  )
}

export default Users
